import isNil from 'lodash/isNil'
import React, { useEffect } from 'react'
import { useContext as useContextParent } from '../Context'
import { SearchFieldsDropdown } from './SearchFieldsDropdown'
import { ShowIf } from '@ztechapps/webui.util'
import { useSearchInputContext } from './Context'

export const SearchInputLayout = () => {
  const { searchPlaceHolder, searchByField, onChangeSearchField, searchValue, loading } = useContextParent()
  const { handleChange, onKeyDown } = useSearchInputContext()
  const inputRef = React.useRef<HTMLInputElement>(null)

  const [onFocusOnce, setOnFocusOnce] = React.useState(false)
  useEffect(() => {
    if (loading && !onFocusOnce) return
    inputRef.current && inputRef.current.focus()
  }, [loading])

  const onFocus = () => {
    setOnFocusOnce(true)
  }
  const onBlur = () => {
    setOnFocusOnce(false)
  }

  return (
    <>
      <input
        type="search"
        placeholder={searchPlaceHolder}
        value={searchValue ?? ''}
        className="form-control my-search"
        onChange={handleChange}
        onKeyDown={onKeyDown}
        disabled={loading}
        onFocus={onFocus}
        onBlur={onBlur}
        ref={inputRef}
      />

      <ShowIf condition={searchByField && !isNil(onChangeSearchField)}>
        <SearchFieldsDropdown />
      </ShowIf>
    </>
  )
}
